import "./contact.scss"

export default function Contact() {
    return (
        <div className="contact" id="contact">
            
        </div>
    )
}

